import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GenericResponse } from '../generic-response';
import { CookingStoryGroceryApiService } from './cooking-story-kitchen-api.service';

@Injectable({
  providedIn: 'root',
})
export class CookingStoryGroceryService {
  constructor(
    private cookingStoryKitchenApiService: CookingStoryGroceryApiService
  ) {}
  openPopUp: Subject<string> = new Subject();
  closeTutorial: Subject<boolean> = new Subject();
  itemAdded: Subject<string> = new Subject();
  toggleAllItems: Subject<boolean> = new Subject();
  toggleAllKitchenItems: Subject<boolean> = new Subject();
  shoppingListDeslecting: Subject<boolean> = new Subject();
  kitchenDeslecting: Subject<boolean> = new Subject();
  changeTab: Subject<boolean> = new Subject();

  getGroceryCategoryListData(): Promise<GenericResponse> {
    return this.cookingStoryKitchenApiService.getGroceryCategoryList();
  }
  getKitchenHomeData(): Promise<GenericResponse> {
    return this.cookingStoryKitchenApiService.getKitchenHomeItem();
  }
  getShoppingListHomeData(): Promise<GenericResponse> {
    return this.cookingStoryKitchenApiService.getShoppingListHomeItem();
  }
}
